var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-center"},[(_vm.can('article.edit_stock'))?_c('div',{staticClass:"j-center"},[_c('stock-btn',{attrs:{"article":_vm.article}}),_c('edit-addresses-stock-btn',{attrs:{"article":_vm.article}})],1):_c('span',[_vm._v(" "+_vm._s(_vm.article.stock)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }